module.exports = __webpack_public_path__ + "img/chamedoon.e307fe4.png";